export const PostalCodeText = 'postal code';
export const ZipCodeText = 'zip code';

export const PostalCodeRegExp = /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} ?\d{1}[A-Za-z]{1}\d{1}$/;
export const ZipCodeRegExp = /^\d{5}(-\d{4})?$/;

export const PricingStatus = {
  Idle: 'Idle',
  Loading: 'Loading',
  Succeeded: 'Succeeded',
  Failed: 'Failed',
};
